import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'AE',
    name: 'Reine Carapace',
    id: 'CarapaceQueen',
    health: 60,
    difficulty: 3,
    additionalInfo: '',
    expeditionRating: 1,
  },
  {
    expansion: 'AE',
    name: 'Masque Tordu',
    id: 'CrookedMask',
    health: 70,
    difficulty: 5,
    additionalInfo: '',
    expeditionRating: 2,
  },
  {
    expansion: 'AE',
    name: 'Prince des Gloutons',
    id: 'PrinceOfGluttons',
    health: 70,
    difficulty: 5,
    additionalInfo: '',
    expeditionRating: 2,
  },
  {
    expansion: 'AE',
    name: 'Rage Incarnée',
    id: 'Rageborne',
    health: 70,
    difficulty: 2,
    additionalInfo: '',
    expeditionRating: 1,
  },
]
